import React, {useEffect, useState} from 'react';
import { Container, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmployeeHoursTable from '../../components/Dashboards/EmployeeTimeDashboard.jsx';
import PersonnelCostsCalculator from "../../components/Dashboards/PersonnelCostsCalculator.jsx";
import NostradamusUrenCorrectie from "../../components/Schedule/NostradamusUrenCorrectie.jsx";
import {jwtDecode} from "jwt-decode";

const ReportPage = () => {
    const [selectedReport, setSelectedReport] = useState('');
    const [role, setRole] = useState(null);
    const reports = [
        { id: 'Onkosten', name: 'Loonkosten' },
        { id: 'employeeHours', name: 'Werknemersuren Rapport' },
        { id: 'UrenCorrectie', name: 'UrenCorrectie' },
    ];

    const ROLES = {
        BAAS: 'BAAS',
        FLOORMANAGER: 'FLOORMANAGER',
        HUMANRESOURCE: 'HUMANRESOURCE',
        HORECAMASTERS: 'HORECAMASTERS',
    };

    useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        if (token) {
            const decodedToken = jwtDecode(token);
            if (decodedToken.roles && decodedToken.roles.length > 0) {
                const userRole = decodedToken.roles[0]; // Neem de eerste rol uit de lijst
                setRole(userRole);
            }
        }
    }, []);

    const handleReportChange = (event) => {
        setSelectedReport(event.target.value);
    };

    const renderReport = () => {
        switch(selectedReport) {
            case 'employeeHours':
                return <EmployeeHoursTable />;
            case 'Onkosten':
                return <PersonnelCostsCalculator/>;
            case 'UrenCorrectie':
                return <NostradamusUrenCorrectie/>;
            default:
                return <NostradamusUrenCorrectie />;
        }
    };

    return (
        <div style={{ height: '100vh', width: "93vw", position: 'relative', display: 'flex', flexDirection: 'column' }}>
            {/* Header met vaste hoogte waarin het dropdown menu staat */}
            <div style={{ height: '60px', padding: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                {(role === ROLES.BAAS ||
                    role === ROLES.FLOORMANAGER ||
                    role === ROLES.HUMANRESOURCE ||
                    role === ROLES.HORECAMASTERS) && (
                    <div style={{ width: '250px' }}>
                        <Form.Select
                            value={selectedReport}
                            onChange={handleReportChange}
                        >
                            <option value="">Kies een rapport</option>
                            {reports.map((report) => (
                                <option key={report.id} value={report.id}>
                                    {report.name}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                )}
            </div>

            {/* Content area met eigen scrollbar */}
            <div style={{ flex: 1, overflowY: 'auto' }}>
                <Container>
                    {renderReport()}
                </Container>
            </div>
        </div>
    );
};

export default ReportPage;
